import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'scheduler-filters',
  templateUrl: './scheduler-filters.component.html'
})
export class SchedulerFiltersComponent implements OnInit, OnChanges {
  @ViewChild(Calendar, { static: true }) calendar: Calendar;
  @Output() filtersChanged = new EventEmitter<any>();
  @Input() initialDate: Date = new Date();

  public filters: { key: string; value: string; }[];
  public daysToShow = 1;
  public filterDate: Date;

  private RADIO_OPTION_TO_HOURS_PER_COLUMN = {
    1: 1,
    2: 4,
    7: 6,
  };

  constructor(
  ) {
  }

  ngOnInit() {
    this.filterDate = this.initialDate ? new Date(this.initialDate) : new Date();
    this.filterUpdate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialDate'] && !changes['initialDate'].firstChange) {

      const previousDate: string = changes['initialDate'].previousValue;
      const currentDate: string = changes['initialDate'].currentValue;

      if (previousDate === currentDate) {
        return;
      }

      this.filterDate = changes['initialDate'].currentValue ? new Date(changes['initialDate'].currentValue) : new Date();
      this.filterUpdate();
    }
  }

  public filterUpdate() {
    this.filterDate.setHours(0, 0, 0, 0);

    let start = new Date(this.filterDate);
    let end = new Date(this.filterDate);
    end.setHours(end.getHours() + (this.daysToShow * 24));

    this.filters = [
      { key: 'startTime', value: start.toISOString() },
      { key: 'endTime', value: end.toISOString() },
    ];

    const hoursPerColumn = this.RADIO_OPTION_TO_HOURS_PER_COLUMN[this.daysToShow];

    this.filtersChanged.emit({
      filters: this.filters,
      hoursPerColumn,
      startTime: start,
      endTime: end,
    });
  }

  public onDaysToShowChange() {
    this.filterUpdate();
  }

  public onFilterStartDateChange() {
    this.filterUpdate();
  }

  public previousDate() {
    this.filterDate.setDate(this.filterDate.getDate() - 1);
    this.calendar.updateInputfield();
    this.filterUpdate();
  }

  public nextDate() {
    this.filterDate.setDate(this.filterDate.getDate() + 1);
    this.calendar.updateInputfield();
    this.filterUpdate();
  }
}
